import { render } from "./SurveyEditor.vue?vue&type=template&id=00abb93c&scoped=true"
import script from "./SurveyEditor.vue?vue&type=script&lang=js"
export * from "./SurveyEditor.vue?vue&type=script&lang=js"

import "./SurveyEditor.vue?vue&type=style&index=0&id=00abb93c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00abb93c"]])

export default __exports__